export const QLPageQA = {
    UndoButton: 'undo-btn',
    RedoButton: 'redo-btn',
};

export const enum ViewSetupQA {
    ViewSetupCreate = 'view-setup-create',
    SelectConnection = 'select-connection',
}

export const enum ScreenEditorQA {
    QueryTab = 'query-tab',
    ParamsTab = 'params-tab',
}

export const enum TabQueryQA {
    AddPromQLQueryBtn = 'add-promql-query-btn',
    SelectConnection = 'select-connection',
}

export const enum TabParamsQA {
    ParamName = 'param-name',
    AddParamBtn = 'add-param-btn',
    ParamType = 'param-type',
    OpenParamDialogBtn = 'open-param-dialog-btn',
}

export const enum DialogQLParameterQA {
    Dialog = 'dialog-ql-param',
    DialogBody = 'dialog-ql-param-body',
    DatepickerStart = 'datepicker-start',
    DatepickerEnd = 'datepicker-end',
}
